
function LbhTerms() {
  return (<div className="container">
    <h2>Terms of Service for <span className="App-title">Happy Now</span></h2>
    <p>Last updated:  August 10th, 2025</p>
    <p>Welcome to <span className="App-title">Happy Now</span> ("we," "our," or "us"). By accessing or using our game app, <span className="App-title">Happy Now</span> ("the App"), you agree to comply with and be bound by these Terms of Service ("Terms"). If you disagree with any part of these Terms, please do not use our App.</p>

    <h2>1. Acceptance of Terms</h2>
    <p>By downloading, installing, or using <span className="App-title">Happy Now</span>, you accept and agree to these Terms. If you are under 18, you must have parental or legal guardian consent to use the App.</p>

    <h2>2. License to Use</h2>
    <p>We grant you a limited, non-exclusive, non-transferable, and revocable license to download, install, and use <span className="App-title">Happy Now</span> solely for personal, non-commercial entertainment purposes. You may not copy, modify, distribute, sell, or lease any part of the App unless we give you explicit permission in writing.</p>

    <h2>3. User Accounts</h2>
    <p>No users accounts.</p>

    <h2>4. Virtual Goods and In-App Purchases</h2>
    <p><span className="App-title">Happy Now</span> may offer in-app purchases of virtual goods, such as game currency, power-ups, and items. Virtual goods have no real-world value, and they:</p>
    <ul>
      <li>Cannot be redeemed for cash or transferred to others.</li>
      <li>Are non-refundable.</li>
      <li>Remain our property, even after purchase.</li>
    </ul>
    <p>We reserve the right to modify, manage, control, and remove virtual goods at our discretion.</p>

    <h2>5. User Conduct</h2>
    <p>You agree not to:</p>
    <ul>
      <li>Use the App for any unlawful or abusive purpose.</li>
      <li>Disrupt or interfere with the App, servers, or networks.</li>
      <li>Use automated means to interact with the App or collect user information.</li>
      <li>Post or share offensive, obscene, or inappropriate content.</li>
    </ul>
    <p>Violating these rules may result in the suspension or termination of your access to <span className="App-title">Happy Now</span>.</p>

    <h2>6. Intellectual Property</h2>
    <p>All content within <span className="App-title">Happy Now</span>, including images, graphics, music, and code, is owned by us or our licensors and protected by copyright and other intellectual property laws. You may not use our intellectual property without our prior written consent.</p>

    <h2>7. Disclaimer of Warranties</h2>
    <p><span className="App-title">Happy Now</span> is provided "as is" without any warranties of any kind. We do not guarantee that the App will function uninterrupted, be error-free, or be free of viruses or other harmful components. Use the App at your own risk.</p>

    <h2>8. Limitation of Liability</h2>
    <p>To the maximum extent permitted by law, we shall not be liable for any damages arising from your use of, or inability to use, <span className="App-title">Happy Now</span>. This includes any direct, indirect, incidental, consequential, or punitive damages, even if we were advised of the possibility of such damages.</p>

    <h2>9. Indemnification</h2>
    <p>You agree to indemnify, defend, and hold harmless <span className="App-title">Happy Now</span>, its affiliates, and their respective employees, contractors, and agents from and against any claims, liabilities, damages, losses, and expenses, including legal fees, arising from your use of the App or violation of these Terms.</p>

    <h2>10. Termination</h2>
    <p>We reserve the right to terminate or suspend your access to <span className="App-title">Happy Now</span> at our discretion, without prior notice, if you violate these Terms or if we discontinue the App. Upon termination, all licenses and rights granted to you will end immediately.</p>

    <h2>11. Changes to These Terms</h2>
    <p>We may modify these Terms at any time, and any changes will become effective upon posting. Your continued use of <span className="App-title">Happy Now</span> after any changes indicates your acceptance of the revised Terms.</p>

    <h2>12. Governing Law</h2>
    <p>These Terms are governed by and construed in accordance with the laws of France.</p>

    <h2>13. Contact Us</h2>
    <p>If you have questions about these Terms, please contact us at:</p>

    <p>Email: tryciaspas at gmail dot com</p>
  </div>);
}
export default LbhTerms;
